<template>
  <div class="aboutUs client">
    <!--1:banner-->
    <div class="block banner">
      <div :class="{content:true}">
        <div class="item1">
          <div class="box">
            <p :class="{title:true,animated:true,fadeInUp:isUp,delay2s:true}">客户案例</p>
            <div :class="{detail:true,animated:true,fadeInUp:isUp,delay4s:true}">
              越来越多的用户正在使用基于牛盾所开发的产品服务。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--2:-->
    <div class="block clientCase">
      <ul class="ul_box flex_around">
        <li class="flexCol_aroud" @click="clientDetail('/client1')">
          <i class="icon_clientCase icon_clientCase01"></i>
          <p>都邦保险成立于2005年，旗下拥有33家分公司和400多家分支机构，形成了覆盖全国的机构服务网络。</p>
        </li>
        <li class="flexCol_aroud" @click="clientDetail('/client2')">
          <i class="icon_clientCase icon_clientCase02"></i>
          <p>众安在线财产保险股份有限公司是中国首家互联网保险公司，2017年在香港联合交易所主板上市。</p>
        </li>
        <li class="flexCol_aroud" @click="clientDetail('/client3')">
          <i class="icon_clientCase icon_clientCase03"></i>
          <p>新网银行是全国三家互联网银行之一，由新希望集团、小米、红旗连锁等股东发起设立，是银监会批准成立的全国第七家民营银行。</p>
        </li>
      </ul>
      <ul class="ul_box flex_around">
        <li class="flexCol_aroud" @click="clientDetail('/client4')">
          <i class="icon_clientCase icon_clientCase04"></i>
          <p>夏娃科技是一家以“保护生育力”为宗旨的公司，致力于为中国女性提供科学、全面的生育力保护整体解决方案。</p>
        </li>
        <li class="flexCol_aroud" @click="clientDetail('/client5')">
          <i class="icon_clientCase icon_clientCase05"></i>
          <p>台州市大数据管理中心为台州市政府直属正县级事业单位，主要负责全市大数据资源统筹管理工作。</p>
        </li>
        <li class="flexCol_aroud" @click="clientDetail('/client6')">
          <i class="icon_clientCase icon_clientCase06"></i>
          <p>杭州市妇产科医院（杭州市妇幼保健院）是杭州市卫计委直属的集医疗、保健、教学、科研于一体的公立医院。</p>
        </li>
      </ul>
    </div>
    <!--foot-->
    <div class="foot">
      <footBar></footBar>
    </div>
    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import footBar from '../../components/footerbar'
  import returnTop from '../../components/returnTop'
  import Case from '../../components/case'

  export default {
    name: "client",
    data() {
      return {
        checkboxGroup: [],
        form:{
          name:''
        },
        activeName: 'first',
        swiperOption: {
          autoplay: false,
          speed: 500,
          loop: true,
          type: 'custom',
          navigation: {
            nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          },
          pagination: {
            el: '.pag',
            bulletElement: "li",

          }
        },
        swiperOption2: {
          autoplay: true,
          speed: 300,
          loop: true,
          pagination: '.swiper-pag',
        },
        isUp: false,
        isUp1: false,
        isUp2: false,
        isUp3: false,
        isDisplay1: true,
        isDisplay2: true,
        isDisplay3: true,
      }
    },
    components: {
      footBar, Case,returnTop
    },
    mounted() {
      this.isUp = true;
    },
    methods: {
      onSubmit(){
        console.log('form1',this.form);
      },
      goU(url) {
        this.$router.push({name: url});
      },
    },
    destroyed() {
      window.removeEventListener('scroll', this.scrollFun);
    },
    methods:{
      clientDetail(url){
        console.log(url);
        this.$router.push(url);
      }
    }
  }
</script>

<style scoped lang="scss">
  .clientCase{
    .ul_box{
      li{
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/client/client.vue